import React from 'react';

import { ModalTrigger } from '@atlassian/entry-points/modal-trigger';
import { FullScreenModalTrigger } from '@atlassian/entry-points/full-screen-modal-trigger';
import { fg } from '@atlassian/jira-feature-gating';
import { mergeRefs } from '@atlassian/jira-merge-refs/src/index.tsx';
import type { CreateHubModalEntrypointProps } from './CreateHubModal.entrypoint.types.tsx';
import { createHubModalEntryPoint } from './createHubModalEntryPoint.entrypoint.tsx';

type CreateHubModalTriggerProps = {
	children: (props: { buttonRef: React.RefCallback<HTMLButtonElement> }) => React.ReactNode;
	entryPointProps?: Omit<CreateHubModalEntrypointProps, 'onClose'>;
};

export const CreateHubModalTrigger = ({
	children,
	entryPointProps,
}: CreateHubModalTriggerProps): React.JSX.Element => {
	const renderTrigger = ({ ref }: { ref: React.Ref<HTMLElement> }): React.ReactNode => {
		return children({ buttonRef: mergeRefs(ref) });
	};

	if (fg('csm_ai_create_customer_experience_v2')) {
		return (
			<FullScreenModalTrigger
				entryPoint={createHubModalEntryPoint}
				entryPointProps={entryPointProps}
			>
				{renderTrigger}
			</FullScreenModalTrigger>
		);
	}

	return (
		<ModalTrigger
			entryPoint={createHubModalEntryPoint}
			modalProps={{ width: 'x-large' }}
			entryPointProps={entryPointProps}
		>
			{renderTrigger}
		</ModalTrigger>
	);
};
